/* Country rates are CZK, regardless of the active market currency. */
(function () {
  'use strict';
  var source = document.querySelector('script[data-ship-zeme]'), rates;
  try { rates = JSON.parse(source.textContent); } catch (e) { return; }
  if (!rates || typeof rates !== 'object' || Array.isArray(rates)) return;
  var countries = Object.keys(rates).filter(function (cc) { return /^[A-Z]{2}$/.test(cc); });
  var key = 'capkov_ship_cc', selected;
  var languages = { de: 'DE', fr: 'FR', it: 'IT', es: 'ES', nl: 'NL', pl: 'PL', hu: 'HU', ro: 'RO', hr: 'HR', sl: 'SI', sv: 'SE', da: 'DK', fi: 'FI', bg: 'BG', en: 'IE', uk: 'PL' };
  function rows(cc) {
    if (!Array.isArray(rates[cc])) return [];
    var seen = new Set();
    return rates[cc].filter(function (r) {
      return r && typeof r.c === 'string' && r.c.trim() && (r.t === 'pickup' || r.t === 'home') && typeof r.p === 'number' && Number.isFinite(r.p) && r.p >= 0;
    }).sort(function (a, b) { return a.p - b.p; }).filter(function (r) {
      var id = JSON.stringify([r.c, r.t]);
      if (seen.has(id)) return false;
      seen.add(id); return true;
    }).slice(0, 6);
  }
  if (!countries.some(function (cc) { return rows(cc).length; })) return;
  function initial(config) {
    var saved;
    try { saved = localStorage.getItem(key); } catch (e) { /* Storage may be blocked. */ }
    if (countries.indexOf(saved) !== -1) return saved;
    if (config.country !== 'CZ' && countries.indexOf(config.country) !== -1) return config.country;
    var language = config.locale.toLowerCase().split('-')[0];
    return countries.indexOf(languages[language]) !== -1 ? languages[language] : countries[0];
  }
  function element(tag, text, className) {
    var node = document.createElement(tag);
    if (text !== undefined) node.textContent = text;
    if (className) node.className = className;
    return node;
  }
  function render(widget) {
    var controls = widget.querySelector('[data-ship-controls]'), config = controls.dataset;
    var list = controls.querySelector('[data-ship-rows]'), items = rows(selected);
    controls.querySelector('select').value = selected;
    var lb = controls.querySelector('.rd-ship__btn-t'), sel = controls.querySelector('select');
    if (lb && sel.selectedIndex >= 0) lb.textContent = sel.options[sel.selectedIndex].text;
    controls.querySelectorAll('.rd-ship__opt').forEach(function (o) { o.setAttribute('aria-selected', o.getAttribute('data-cc') === selected ? 'true' : 'false'); });
    list.replaceChildren();
    items.forEach(function (r) {
      var li = element('li'), logo = config[r.c.toLowerCase()];
      if (['GLS', 'DPD', 'PPL', 'Packeta'].indexOf(r.c) !== -1 && logo) {
        var img = element('img'); img.src = logo; img.alt = r.c;
        img.width = 96; img.height = 34; img.loading = 'lazy'; li.appendChild(img);
      } else { li.appendChild(element('span', r.c, 'rd-ship__carrier')); }
      li.appendChild(element('span', r.t === 'pickup' ? config.pick : config.home, 'rd-ship__type'));
      li.appendChild(element('b', config.from.trim() + ' ' + r.p + '\u00a0Kč' + (config.free ? ' · ' + config.free : ''), 'rd-ship__price'));
      list.appendChild(li);
    });
    list.hidden = !items.length;
    controls.querySelector('[data-ship-eta]').hidden = !items.length || selected === 'CZ';
    widget.querySelector('[data-ship-fallback]').hidden = !!items.length;
    controls.hidden = false;
  }

  /* 23. 10. majitel: místo systémového seznamu vlastní okno (jako výběr jazyka). <select> zůstává skrytý kvůli logice a čtečkám. */
  function enhance(controls, select) {
    if (controls.querySelector('.rd-ship__btn')) return;
    var wrap = element('div', undefined, 'rd-ship__pick');
    var btn = element('button', undefined, 'rd-ship__btn'); btn.type = 'button';
    btn.setAttribute('aria-haspopup', 'listbox'); btn.setAttribute('aria-expanded', 'false');
    btn.appendChild(element('span', '', 'rd-ship__btn-t'));
    var chev = document.createElementNS('http://www.w3.org/2000/svg', 'svg'); chev.setAttribute('viewBox', '0 0 24 24'); chev.setAttribute('aria-hidden', 'true');
    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path'); path.setAttribute('d', 'M6 9l6 6 6-6'); chev.appendChild(path); btn.appendChild(chev);
    var list = element('ul', undefined, 'rd-ship__list'); list.setAttribute('role', 'listbox'); list.hidden = true; list.tabIndex = -1;
    [].forEach.call(select.options, function (o) {
      var li = element('li', o.text, 'rd-ship__opt'); li.setAttribute('role', 'option'); li.setAttribute('data-cc', o.value); li.tabIndex = -1;
      li.addEventListener('click', function () { choose(o.value); });
      list.appendChild(li);
    });
    function open(v) {
      list.hidden = !v; btn.setAttribute('aria-expanded', v ? 'true' : 'false'); wrap.classList.toggle('is-open', v);
      if (v) { var cur = list.querySelector('[aria-selected="true"]') || list.firstChild; if (cur) { cur.focus(); cur.scrollIntoView({ block: 'nearest' }); } }
    }
    function choose(cc) { select.value = cc; select.dispatchEvent(new Event('change', { bubbles: true })); open(false); btn.focus(); }
    btn.addEventListener('click', function (e) { e.stopPropagation(); open(list.hidden); });
    list.addEventListener('keydown', function (e) {
      var items = [].slice.call(list.children), i = items.indexOf(document.activeElement);
      if (e.key === 'Escape') { e.preventDefault(); open(false); btn.focus(); }
      else if (e.key === 'ArrowDown') { e.preventDefault(); (items[i + 1] || items[0]).focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); (items[i - 1] || items[items.length - 1]).focus(); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (items[i]) choose(items[i].getAttribute('data-cc')); }
    });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) open(false); });
    select.classList.add('rd-ship__native'); select.tabIndex = -1; select.setAttribute('aria-hidden', 'true');
    select.parentNode.insertBefore(wrap, select); wrap.appendChild(btn); wrap.appendChild(list);
  }
  function sync() {
    document.querySelectorAll('[data-ship-widget][data-ship-ready]').forEach(render);
    /* dobírka jen CZ a SK */
    document.querySelectorAll('[data-ship-cod]').forEach(function (el) { el.hidden = !!selected && selected !== 'CZ' && selected !== 'SK'; });
  }
  function init() {
    document.querySelectorAll('[data-ship-widget]:not([data-ship-ready])').forEach(function (widget) {
      var controls = widget.querySelector('[data-ship-controls]'), config = controls.dataset;
      if (config.locale === 'cs') return;
      if (!selected) selected = initial(config);
      var names;
      try { names = new Intl.DisplayNames([config.locale], { type: 'region' }); } catch (e) { /* Use country codes. */ }
      var select = controls.querySelector('select');
      countries.forEach(function (cc) {
        var name = cc;
        try { if (names) name = names.of(cc) || cc; } catch (e) { /* Use country code. */ }
        var option = element('option', name); option.value = cc; select.appendChild(option);
      });
      select.addEventListener('change', function () {
        selected = select.value;
        try { localStorage.setItem(key, selected); } catch (e) { /* Keep in-memory selection. */ }
        sync();
      });
      enhance(controls, select);
      widget.setAttribute('data-ship-ready', ''); render(widget); sync();
    });
  }
  document.addEventListener('capkov:shipping-open', init);
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('storage', function (event) {
    if (event.key === key && countries.indexOf(event.newValue) !== -1) { selected = event.newValue; sync(); }
  });
  init();
})();
